import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#12121A] text-[#F3F3F3] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/0e1876b0-5fab-4c7b-9ead-68bed976d72a.png" 
                alt="PLADUREX Logo" 
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold text-[#F3F3F3]">PLADUREX</span>
            </div>
            <p className="text-sm text-[#F3F3F3]/70 leading-relaxed break-words">
              Especialistas en instalación de pladur en Mataró y comarca del Maresme. Obra limpia, rápida y profesional. <Link to="/empresa" className="text-[#FF007A] hover:underline">Conoce más sobre nosotros</Link>.
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 text-[#FF007A]">Navegación</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">Inicio</Link></li>
              <li><Link to="/empresa" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">Empresa</Link></li>
              <li><Link to="/servicios" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">Servicios</Link></li>
              <li><Link to="/faq" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">FAQ</Link></li>
              <li><Link to="/contacto" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">Contacto</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 text-[#FF007A]">Servicios</h4>
            <ul className="space-y-2">
              <li><Link to="/servicios#tabiques" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Tabiques de pladur</Link></li>
              <li><Link to="/servicios#trasdosados" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Trasdosados</Link></li>
              <li><Link to="/servicios#techos" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Falsos techos</Link></li>
              <li><Link to="/servicios#acustico" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Aislamiento acústico</Link></li>
              <li><Link to="/servicios#termico" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Aislamiento térmico</Link></li>
              <li><Link to="/servicios" className="text-sm text-[#F3F3F3]/70 hover:text-[#FF007A] transition-colors duration-200 break-words">Reformas integrales</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 text-[#FF007A]">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#FF007A] mt-1 mr-3 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <a href="tel:+34629501941" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-all">
                  +34 629 501 941
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-whatsapp-line text-[#FF007A] mt-1 mr-3 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <a href="https://wa.me/34629501941" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#FF007A] mt-1 mr-3 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-sm text-[#F3F3F3]/70 break-words">
                  Mataró, Maresme, Barcelona
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-question-line text-[#FF007A] mt-1 mr-3 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <Link to="/faq" className="text-sm hover:text-[#FF007A] transition-colors duration-200 break-words">
                  Preguntas frecuentes
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F3F3F3]/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-[#F3F3F3]/60 gap-4">
            <p className="break-words text-center md:text-left">&copy; {currentYear} PLADUREX. Todos los derechos reservados.</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/politica-privacidad" className="hover:text-[#FF007A] transition-colors duration-200">Política de Privacidad</Link>
              <Link to="/politica-cookies" className="hover:text-[#FF007A] transition-colors duration-200">Política de Cookies</Link>
              <Link to="/aviso-legal" className="hover:text-[#FF007A] transition-colors duration-200">Aviso Legal</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
